var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-group",on:{"click":_vm.joinGroup}},[_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.content)+" ")]),_c('div',{staticClass:"join-group-btn"},[_vm._v(" 加入群聊 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }